import React from 'react'

import { Field } from 'formik'

// import { ZariContext } from '_zari/context'

import { Form, Col, Row } from '_zari/core'

import DocumentosRelacionadosConstant from 'constants/tiposDeDocumentosRelacionadosCuentaContable'

const TipoDocumentoFormGroup = ({ fIsSubmitting, iValue, vPrefijo, handleChange }) => {
  // const __zariContext = React.useContext(ZariContext)

  const disabledByBancos = React.useMemo(() => {
    return false
    // return vPrefijo.startsWith('104')
  }, [])

  const disabledByActivoFijo = React.useMemo(() => {
    return false
    // return vPrefijo.startsWith('33') || vPrefijo.startsWith('34')
  }, [])

  const disabledByDepreciacion = React.useMemo(() => {
    return false
    // return vPrefijo.startsWith('39')
  }, [])

  // const changeTipoDocumentoRelacionadoHandler = React.useCallback(
  //   e => {
  //     // const selectedValue = e.target.value
  //     // if (
  //     //   selectedValue === DocumentosRelacionadosConstant.CAJA ||
  //     //   selectedValue === DocumentosRelacionadosConstant.BANCOS
  //     // ) {
  //     //   if (vPrefijo.startsWith('10')) {
  //     //     handleChange(e)
  //     //   } else {
  //     //     e.preventDefault()
  //     //     __zariContext.snack(
  //     //       'warning',
  //     //       'Solo las cuentas de clase "10" pueden usar CAJA o BANCOS.'
  //     //     )
  //     //   }
  //     // } else {
  //     // }
  //     handleChange(e)
  //   },
  //   [handleChange]
  // )

  return (
    <Form.Group>
      <Form.Label text='TIPO DOC.' htmlFor='checkbox-tipoDocumento' md={2} />
      <Col md={10} className='col-tipoDocumento'>
        <Row>
          <Col md={3}>
            <Field name='tipoDocumento'>
              {({ field }) => (
                <Form.Radio
                  {...field}
                  disabled={
                    fIsSubmitting ||
                    disabledByBancos ||
                    disabledByActivoFijo ||
                    disabledByDepreciacion
                  }
                  // onChange={changeTipoDocumentoRelacionadoHandler}
                  checked={iValue === DocumentosRelacionadosConstant.NINGUNO}
                  id='radio-flagNinguno'
                  label={
                    DocumentosRelacionadosConstant.__dictionary[
                      DocumentosRelacionadosConstant.NINGUNO
                    ].nombre
                  }
                  value={
                    DocumentosRelacionadosConstant.__dictionary[
                      DocumentosRelacionadosConstant.NINGUNO
                    ].id
                  }
                />
              )}
            </Field>
          </Col>
          <Col md={3}>
            <Field name='tipoDocumento'>
              {({ field }) => (
                <Form.Radio
                  {...field}
                  disabled={
                    fIsSubmitting ||
                    disabledByBancos ||
                    disabledByActivoFijo ||
                    disabledByDepreciacion
                  }
                  // onChange={changeTipoDocumentoRelacionadoHandler}
                  checked={iValue === DocumentosRelacionadosConstant.BANCOS}
                  id='radio-flagBancos'
                  label={
                    DocumentosRelacionadosConstant.__dictionary[
                      DocumentosRelacionadosConstant.BANCOS
                    ].nombre
                  }
                  value={
                    DocumentosRelacionadosConstant.__dictionary[
                      DocumentosRelacionadosConstant.BANCOS
                    ].id
                  }
                />
              )}
            </Field>
          </Col>
          <Col md={4}>
            <Field name='tipoDocumento'>
              {({ field }) => (
                <Form.Radio
                  {...field}
                  disabled={
                    fIsSubmitting ||
                    disabledByBancos ||
                    disabledByActivoFijo ||
                    disabledByDepreciacion
                  }
                  // onChange={changeTipoDocumentoRelacionadoHandler}
                  checked={iValue === DocumentosRelacionadosConstant.DOCUMENTOS_VARIOS}
                  id='radio-flagDocumentosVarios'
                  label={
                    DocumentosRelacionadosConstant.__dictionary[
                      DocumentosRelacionadosConstant.DOCUMENTOS_VARIOS
                    ].nombre
                  }
                  value={
                    DocumentosRelacionadosConstant.__dictionary[
                      DocumentosRelacionadosConstant.DOCUMENTOS_VARIOS
                    ].id
                  }
                />
              )}
            </Field>
          </Col>
          <Col md={2}>
            <Field name='tipoDocumento'>
              {({ field }) => (
                <Form.Radio
                  {...field}
                  disabled={
                    fIsSubmitting ||
                    disabledByBancos ||
                    disabledByActivoFijo ||
                    disabledByDepreciacion
                  }
                  // onChange={changeTipoDocumentoRelacionadoHandler}
                  checked={iValue === DocumentosRelacionadosConstant.CAJA}
                  id='radio-flagCaja'
                  label={
                    DocumentosRelacionadosConstant.__dictionary[DocumentosRelacionadosConstant.CAJA]
                      .nombre
                  }
                  value={
                    DocumentosRelacionadosConstant.__dictionary[DocumentosRelacionadosConstant.CAJA]
                      .id
                  }
                />
              )}
            </Field>
          </Col>
        </Row>
        <Row>
          <Col md={3}>
            <Field name='tipoDocumento'>
              {({ field }) => (
                <Form.Radio
                  {...field}
                  disabled={
                    fIsSubmitting ||
                    disabledByBancos ||
                    disabledByActivoFijo ||
                    disabledByDepreciacion
                  }
                  // onChange={changeTipoDocumentoRelacionadoHandler}
                  checked={iValue === DocumentosRelacionadosConstant.ACTIVO_FIJO}
                  id='radio-flagActivoFijo'
                  label={
                    DocumentosRelacionadosConstant.__dictionary[
                      DocumentosRelacionadosConstant.ACTIVO_FIJO
                    ].nombre
                  }
                  value={
                    DocumentosRelacionadosConstant.__dictionary[
                      DocumentosRelacionadosConstant.ACTIVO_FIJO
                    ].id
                  }
                />
              )}
            </Field>
          </Col>
          <Col md={3}>
            <Field name='tipoDocumento'>
              {({ field }) => (
                <Form.Radio
                  {...field}
                  disabled={
                    fIsSubmitting ||
                    disabledByBancos ||
                    disabledByActivoFijo ||
                    disabledByDepreciacion
                  }
                  // onChange={changeTipoDocumentoRelacionadoHandler}
                  checked={iValue === DocumentosRelacionadosConstant.DEPRECIACION}
                  id='radio-flagDepreciacion'
                  label={
                    DocumentosRelacionadosConstant.__dictionary[
                      DocumentosRelacionadosConstant.DEPRECIACION
                    ].nombre
                  }
                  value={
                    DocumentosRelacionadosConstant.__dictionary[
                      DocumentosRelacionadosConstant.DEPRECIACION
                    ].id
                  }
                />
              )}
            </Field>
          </Col>
          <Col md={4}>
            <Field name='tipoDocumento'>
              {({ field }) => (
                <Form.Radio
                  {...field}
                  disabled={
                    fIsSubmitting ||
                    disabledByBancos ||
                    disabledByActivoFijo ||
                    disabledByDepreciacion
                  }
                  // onChange={changeTipoDocumentoRelacionadoHandler}
                  checked={iValue === DocumentosRelacionadosConstant.OPCIONAL}
                  id='radio-flagOpcional'
                  label={
                    DocumentosRelacionadosConstant.__dictionary[
                      DocumentosRelacionadosConstant.OPCIONAL
                    ].nombre
                  }
                  value={
                    DocumentosRelacionadosConstant.__dictionary[
                      DocumentosRelacionadosConstant.OPCIONAL
                    ].id
                  }
                />
              )}
            </Field>
          </Col>
        </Row>
      </Col>
    </Form.Group>
  )
}

export default React.memo(TipoDocumentoFormGroup)
